import type { KeyboardEvent } from 'react';

/**
 * Fokussiert die naechste editierbare Inline-Zelle in DOM-Reihenfolge. Da die
 * Zeilen Zelle-fuer-Zelle (und nur sichtbare Spalten) gerendert werden, ist
 * "naechstes Feld in DOM-Reihenfolge" exakt: naechste Spalte; in der letzten
 * Spalte die erste Spalte der naechsten Zeile.
 */
export function focusNextInlineCell(from: HTMLElement | null): void {
  if (!from) return;
  const table = from.closest('table');
  if (!table) return;
  // MUI-Select rendert ein verstecktes aria-hidden/tabindex=-1-input; ueber die
  // Selektoren ausgeschlossen, damit nur die sichtbaren Bedienfelder zaehlen.
  const cells = Array.from(
    table.querySelectorAll<HTMLElement>(
      'input:not([type="hidden"]):not([disabled]):not([aria-hidden="true"]), .MuiSelect-select',
    ),
  ).filter((el) => el.getAttribute('tabindex') !== '-1');
  const i = cells.indexOf(from);
  if (i === -1) return;
  const next = cells[i + 1];
  if (!next) return;
  next.focus();
  if (next instanceof HTMLInputElement) next.select();
}

/**
 * Enter-Handler fuer Inline-Edit-Zellen: loest Speichern (`save`) aus UND springt
 * in die naechste editierbare Spalte; in der letzten Spalte in die erste Spalte
 * der naechsten Zeile. Shift/Ctrl/Meta/Alt+Enter bleiben unberuehrt (z. B. fuer
 * mehrzeilige Felder).
 */
export function handleInlineEditKeyDown(e: KeyboardEvent, save: () => void): void {
  if (e.key !== 'Enter' || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;
  e.preventDefault();
  save();
  focusNextInlineCell(e.target as HTMLElement);
}
